import { da } from './languages/danish';
import { en_GB } from './languages/englishGreatBritain';
import { en_XA } from './languages/englishPseudoLocale';
import { en } from './languages/englishUnitedStates';
import { fi } from './languages/finnish';
import { fr_FR } from './languages/french';
import { fr_CA } from './languages/frenchCanadian';
import { de_DE } from './languages/german';
import { el } from './languages/greek';
import { it } from './languages/italian';
import { pt } from './languages/portuguese';
import { pt_BR } from './languages/portugueseBrazilian';
import { es } from './languages/spanish';
import { es_419 } from './languages/spanishLatinAmerica';
import { sv } from './languages/swedish';
import { nl_BL } from './languages/belgianDutch';

export const dictionary = {
  da,
  "en-GB": en_GB,
  "en-XA": en_XA,
  en,
  fi,
  "fr": fr_FR,
  "fr-CA": fr_CA,
  "de": de_DE,
  el,
  it,
  pt,
  "pt-BR": pt_BR,
  es,
  "es-419": es_419,
  sv,
  "nl-be": nl_BL,
  "nl": nl_BL
};
